<template>
  <div class="g-footer" :style="{paddingLeft: paddingFooter}">
    <v-container grid-list-xl>
      <v-layout class="ex-footer-content">
        <v-flex d-flex align-center>
            <span>{{$t('find_us_on')}}</span>
            <a href="https://www.facebook.com/giverarmenia/" style="height: 35px" target="_blank" class="d-flex"><img src="../../assets/images/fb.svg" alt=""></a>
            <a href="https://www.instagram.com/giverarmenia/" target="_blank" class="d-flex"><img src="../../assets/images/insta.png" alt=""></a>
        </v-flex>
        <v-flex d-flex justify-center pa-0>
            <p class="ex-copyright-text text-xs-center">&copy; {{getCurrentYear}}. {{$t('get_year')}} <a target="_blank" href="https://esterox.am" class="footer-prod">
              <img src="../../assets/images/icons/esterox.png" alt="Esterox"> Esterox</a>
            </p>
        </v-flex>
        <v-flex d-flex justify-space-around class="pa-0-sm">
          <div class="g-tooltip">
            <span class="d-flex"><router-link to="/terms-and-conditions" class="footerterms" exact>{{$t('terms_and_conditions')}}</router-link></span>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  props: {
    paddingLeft: {
      required: false,
      default: null
    }
  },
  data: () => ({}),
  computed: {
    paddingFooter () {
      try {
        // eslint-disable-next-line no-throw-literal
        if (this.paddingLeft) throw this.paddingLeft + 'px'
      } catch (err) {
        return this.paddingLeft + 'px'
      }
    },
    getCurrentYear () {
      let date = new Date()
      return date.getFullYear()
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
  @import "../../assets/sass/desktop/footer.scss";
</style>



// WEBPACK FOOTER //
// src/components/global/Footer.vue